const brushColors = {
    bgRed1: `rgb(113, 0, 0)`,
    bgRed2: `rgb(189, 0, 0)`,
    bgRed3: `rgb(255, 0, 0)`,
    bgRed4: `rgb(252, 29, 29)`,
    bgRed5: `rgb(253, 77, 77)`,
    bgRed6: `rgb(249, 136, 136)`,
    bgOrange1:`rgb(142, 92, 0)`,
    bgOrange2:`rgb(199, 129, 0)`,
    bgOrange3:`rgb(255, 166, 0)`,
    bgOrange4:`rgb(253, 180, 43)`,
    bgOrange5:`rgb(255, 190, 69)`,
    bgOrange6:`rgb(247, 198, 105)`,
    bgYellow1:`rgb(105, 105, 0)`,
    bgYellow2:`rgb(179, 179, 0)`,
    bgYellow3:`rgb(255, 255, 0)`,
    bgYellow4:`rgb(255, 255, 63)`,
    bgYellow5:`rgb(249, 249, 91)`,
    bgYellow6:`rgb(248, 248, 131)`,
    bgGreen1:`rgb(0, 65, 0)`,
    bgGreen2:`rgb(0, 131, 0)`,
    bgGreen3:`rgb(0, 255, 0)`,
    bgGreen4:`rgb(71, 249, 71)`,
    bgGreen5:`rgb(139, 255, 139)`,
    bgGreen6:`rgb(150, 255, 150)`,
    bgBlue1:`rgb(0, 0, 110)`,
    bgBlue2:`rgb(0, 0, 169)`,
    bgBlue3:`rgb(0, 0, 255)`,
    bgBlue4:`rgb(40, 40, 255)`,
    bgBlue5:`rgb(77, 77, 255)`,
    bgBlue6:`rgb(133, 133, 250)`,
    bgPink1:`rgb(100, 0, 88)`,
    bgPink2:`rgb(154, 0, 136)`,
    bgPink3:`rgb(255, 0, 225)`,
    bgPink4:`rgb(237, 54, 253)`,
    bgPink5:`rgb(255, 112, 238)`,
    bgPink6:`rgb(250, 133, 236)`,
    bgBlack1:`rgb(0, 0, 0)`,
    bgBlack2:`rgb(54, 54, 54)`,
    bgBlack3:`rgb(148, 148, 148)`,
    bgBlack4:`rgb(192, 192, 192)`,
    bgBlack5:`rgb(255, 255, 255)`,
    bgBlack6:`rgba(0, 0, 0, 0)`,
}

export default brushColors